import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import LandingPage from "./components/landing/LandingPage";
import ActivityPage from "./components/pages/ActivityPage";
import PacksPage from "./components/pages/PacksPage";
import PaymentSuccessPage from "./components/pages/PaymentSuccessPage";
import AboutPage from "./components/pages/AboutPage";
import HreflangTags from "./components/common/HreflangTags";

function AppContent() {
  return (
    <>
      <HreflangTags />
      <Routes>
        {/* French Routes (default) */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/packs" element={<PacksPage />} />
        <Route path="/paiement-confirme" element={<PaymentSuccessPage />} />
        <Route path="/qui-suis-je" element={<AboutPage />} />
        <Route path="/:slug" element={<ActivityPage />} />
        
        {/* English Routes */}
        <Route path="/en" element={<LandingPage />} />
        <Route path="/en/packs" element={<PacksPage />} />
        <Route path="/en/payment-confirmed" element={<PaymentSuccessPage />} />
        <Route path="/en/who-am-i" element={<AboutPage />} />
        <Route path="/en/:slug" element={<ActivityPage />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <AppContent />
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
